(function() {
  'use strict';
  
  /********************* POPUP INIT *********************/
  let scrollbarWidth = window.innerWidth - document.body.offsetWidth;
  window.addEventListener('resize', () => {
    scrollbarWidth = window.innerWidth - document.body.offsetWidth;
  }, true);

  const settings = {
    speedOpen: 50,
    speedClose: 150,
    activeClass: "is-active",
    visibleClass: "is-visible",
    selectorTarget: "[data-modal-target]",
    selectorTrigger: "[data-modal-trigger]",
    selectorClose: "[data-modal-close]",
  };

  const toggleccessibility = (event) => {
    if (event.getAttribute("aria-expanded") === "true") {
      event.setAttribute("aria-expanded", false);
    } else {
      event.setAttribute("aria-expanded", true);
    }
  };

  // Open Modal
  const openModal = (trigger) => {
    const target = document.getElementById(trigger.getAttribute("data-modal-trigger"));
    target.classList.add(settings.activeClass);
    document.documentElement.classList.add('popup-opened');
    toggleccessibility(trigger);
    document.querySelector('html').style.paddingRight = scrollbarWidth + 'px';

    setTimeout(() => {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen);
  };

  // Close Modal
  const closeModal = (event) => {
    const closestParent = event.closest(settings.selectorTarget);
    closestParent.classList.remove(settings.visibleClass);
    document.documentElement.classList.remove('popup-opened');
    document.querySelector('html').style.paddingRight = '0px';

    setTimeout(() => {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  const clickHandler = (event) => {
    const toggle = event.target;
    const open = toggle.closest(settings.selectorTrigger);
    const close = toggle.closest(settings.selectorClose);

    if (open) {
      openModal(open);
    }

    if (close) {
      closeModal(close);
    }

    if (open || close) {
      event.preventDefault();
    }
  };

  const keydownHandler = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      const modals = document.querySelectorAll(settings.selectorTarget);

      for (let i = 0; i < modals.length; ++i) {
        if (modals[i].classList.contains(settings.activeClass)) {
          closeModal(modals[i]);
        }
      }
    }
  };

  const showModal = (modalName) => {
    if (window.__ubpTpl) {
      const body = document.querySelector('#' + modalName + ' .upsell-brand-popup__body');
      if (body && !body.children.length) {
        body.innerHTML = new TextDecoder().decode(Uint8Array.from(atob(window.__ubpTpl), c => c.charCodeAt(0)));
      }
    }

    let target = document.getElementById(modalName);
    target.classList.add(settings.activeClass);
    target.setAttribute('aria-expanded', true);
    document.documentElement.classList.add('popup-opened');
    document.querySelector('html').style.paddingRight = scrollbarWidth + 'px';
    setTimeout(() => {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen);
  };

  const hideModal = (modalName) => {
    let target = document.getElementById(modalName);
    target.classList.remove(settings.visibleClass);
    target.setAttribute('aria-expanded', false);
    document.documentElement.classList.remove('popup-opened');
    document.querySelector('html').style.paddingRight = '0px';
    setTimeout(() => {
      target.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  document.addEventListener("click", clickHandler, false);
  document.addEventListener("keydown", keydownHandler, false);
  /********************* END POPUP INIT *********************/


  /********************* CHECK COOKIE *********************/
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };

  const parseUpsellCookie = (cookieValue) => {
    if (!cookieValue) return {};
    
    try {
      return JSON.parse(decodeURIComponent(cookieValue));
    } catch (e) {
      return {};
    }
  };

  const saveUpsellCookie = (handles, maxLifetime = 100) => {
    const cookieValue = encodeURIComponent(JSON.stringify(handles));
    setCookie('upsell_brand_handles', cookieValue, maxLifetime);
  };

  const isHandleExpired = (handleData, currentCookieLifetime) => {
    const now = new Date();
    
    if (typeof handleData === 'string') {
      return true;
    }
    
    if (handleData.cookieLifetime !== currentCookieLifetime) {
      return false;
    }
    
    const expiry = new Date(handleData.expiryDate);
    return now > expiry;
  };

  let upsellPopupTimer = null;

  // Schedule popup: requires timeDelay + optional scroll. Shows when both conditions are met.
  const schedulePopup = (callback, timeDelay, scrollTriggerEnabled) => {
    if (!scrollTriggerEnabled) {
      upsellPopupTimer = setTimeout(callback, timeDelay);
      return;
    }

    let timeElapsed = false;
    let hasScrolled = false;
    let shown = false;

    const tryShow = () => {
      if (!shown && timeElapsed && hasScrolled) {
        shown = true;
        window.removeEventListener('scroll', onScroll);
        callback();
      }
    };

    const onScroll = () => {
      if (!hasScrolled) {
        hasScrolled = true;
        tryShow();
      }
    };

    upsellPopupTimer = setTimeout(() => {
      timeElapsed = true;
      tryShow();
    }, timeDelay);

    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const checkUpsellBrandCookie = () => {
    const popup = document.getElementById('upsell-brand-popup');
    if (!popup) return;

    const productHandle = popup.getAttribute('data-product-handle');
    const cookieLifetimeAttr = popup.getAttribute('data-cookie-lifetime');
    const cookieLifetime = cookieLifetimeAttr !== null ? parseInt(cookieLifetimeAttr) : 30;
    const timeDelayAttr = popup.getAttribute('data-time-delay');
    const timeDelay = timeDelayAttr !== null ? parseInt(timeDelayAttr) * 1000 : 0;
    const scrollTriggerAttr = popup.getAttribute('data-scroll-trigger');
    const scrollTriggerEnabled = scrollTriggerAttr === 'true';

    if (!productHandle) return;

    if (cookieLifetime === 0) {
      schedulePopup(() => showModal('upsell-brand-popup'), timeDelay, scrollTriggerEnabled);
      return;
    }

    const cookieValue = getCookie('upsell_brand_handles');
    const handles = parseUpsellCookie(cookieValue);
    
    if (handles[productHandle]) {
      const handleData = handles[productHandle];
      
      if (typeof handleData === 'object' && handleData.cookieLifetime !== cookieLifetime) {
        const createdDate = new Date(handleData.createdDate);
        const newExpiryDate = new Date(createdDate);
        if (cookieLifetime > 0) {
          newExpiryDate.setDate(newExpiryDate.getDate() + cookieLifetime);
        } else {
          newExpiryDate.setTime(createdDate.getTime() - 1000);
        }
        
        handles[productHandle] = {
          createdDate: handleData.createdDate,
          expiryDate: newExpiryDate.toISOString(),
          cookieLifetime: cookieLifetime
        };
        
        if (new Date() <= new Date(handles[productHandle].expiryDate)) {
          saveUpsellCookie(handles, Math.max(cookieLifetime, 100));
          return;
        }
      } else if (!isHandleExpired(handleData, cookieLifetime)) {
        return;
      }
      
      delete handles[productHandle];
    }

    const triggerPopup = () => {
      showModal('upsell-brand-popup');

      const now = new Date();
      const expiryDate = new Date(now);

      if (cookieLifetime > 0) {
        expiryDate.setDate(expiryDate.getDate() + cookieLifetime);

        handles[productHandle] = {
          createdDate: now.toISOString(),
          expiryDate: expiryDate.toISOString(),
          cookieLifetime: cookieLifetime
        };

        saveUpsellCookie(handles, Math.max(cookieLifetime, 100));
        cleanExpiredHandles(handles, cookieLifetime);
      }
    };

    schedulePopup(triggerPopup, timeDelay, scrollTriggerEnabled);
  };

  const cleanExpiredHandles = (handles, currentCookieLifetime) => {
    let hasExpired = false;
    
    for (const handle in handles) {
      const handleData = handles[handle];
      
      if (typeof handleData === 'string' || isHandleExpired(handleData, currentCookieLifetime)) {
        delete handles[handle];
        hasExpired = true;
      }
    }
    
    if (hasExpired) {
      saveUpsellCookie(handles);
    }
  };
  /********************* END CHECK COOKIE *********************/


  document.addEventListener("DOMContentLoaded", () => {
    checkUpsellBrandCookie();
  });

  document.addEventListener("click", (e) => {
    if (!e.target || !e.target.closest) return;

    if (e.target.closest('.upsell-brand-popup__body a[href]')) {
      hideModal('upsell-brand-popup');
    }
  })
})();